import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { HTMLProps, PropsWithChildren, ReactNode } from "react"

const Card = ({ children, className, ...rest }: PropsWithChildren<HTMLProps<HTMLDivElement>>) => {
    return (
        <div {...rest} className={classNames("p-5 rounded-xl border border-white-100", className)}>
            {children}
        </div>
    )
}

const MetricRow = ({
    className,
    title,
    value,
    Icon,
    ...rest
}: PropsWithChildren<HTMLProps<HTMLDivElement>> & {
    title: string
    value: ReactNode
    Icon: Icons.IconComponent
}) => {
    return (
        <div
            {...rest}
            className={classNames("flex items-center justify-between w-full gap-2", className)}
        >
            <div className="flex gap-3 items-center shrink-0">
                <Icons.Icon className="text-gray-400" Icon={Icon} />
                <h5 className="text-gray-400">{title}</h5>
            </div>
            <h5 className="text-gray-0 shrink min-w-0 truncate">{value}</h5>
        </div>
    )
}

export { Card as Card, MetricRow }
